import { render } from "./FooterComponents.vue?vue&type=template&id=e2e574c2"
import script from "./FooterComponents.vue?vue&type=script&lang=js"
export * from "./FooterComponents.vue?vue&type=script&lang=js"

import "./FooterComponents.vue?vue&type=style&index=0&id=e2e574c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__